import { IPagination, option } from "./types";
import { IPriceDetails } from "../components/templates/Lead/PaymentInfo.template";
import { IMAGE_MASTER } from "../services/useImageMasterService";

export const ADDRESS_TYPE = {
    CONTACT_PERSON: "CONTACT_PERSON"
};

export const API_METHOD = {
    POST: "POST",
    GET: "GET",
    PUT: "PUT",
    DELETE: "DELETE",
    PATCH: "PATCH"
}

export const AUTH_PARAMS = {
  KEY: "86482624b33891447d84dade95c301d318d63fad91f420e7525ef190c1f5a745",
}

export const REGEX = {
    EMAIL: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    PASSWORD: /^(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*_\-+=|\\(){}[\]:;'"<>,.?/])(.{8,})$/,
    FULL_NAME: /^[\w'\-,.][^0-9_!¡?÷?¿\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/,
    PHONE_NUMBER: /^\d{10}$/,
    GST_NUMBER: /^[\w\d]{15}$/,
    TAGS_VALIDATION: /^[a-zA-Z0-9\s\-!"#$&'*,./:?@_`~]+$/,
    HSN_VALIDATION: /^\d{8}$/,
    NAME: /^[A-Za-z',.]+(?:\s+[A-Za-z',.]+)*$/,
    GST: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9,A-Z]{1}?$/,
    PINCODE: /^\d{6}$/,
    IFSC: /^[A-Z]{4}[0-9]{7}$/,
    ACCOUNT_NUMBER: /^\d{8,16}$/,
    CIN: /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
    UDHYAM: /^[A-Za-z0-9]{12}$/,
    PAN: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    GSTIN: /(?=^.{15}$)[0-9]{2}[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}/, 
    UPPERCASE: /[A-Z]/,
    LOWERCASE: /[a-z]/,
    SYMBOL: /[!@#$%^&*(),.?":{}|<>]/,
    NUMBER: /[1-9][0-9]*/,
    URL: /^(ftp|http|https):\/\/[^ "]+$/,
}

export const ADMIN_ROUTES = {
    INVENTORY_LIST: "/inventory/list",
    INVENTORY_VIEW: "/inventory/view",
    INVENTORY_UPDATE: "/inventory/update",
    INVENTORY_CREATE: "/inventory/add",
    BRAND_LIST: "/brand",
    BRAND_VIEW: "/brand/:id",
    BRAND_UPDATE: "/brand/:id/update",
    BRAND_CREATE: "/brand/add",
    MANUFACTURER_VIEW: "/manufacturer/:id",
    MANUFACTURER_UPDATE: "/manufacturer/:id/update",
    MANUFACTURER_CREATE: "/manufacturer/add",
    MANUFACTURER_LIST: "/manufacturer",
    SECONDARY_INVENTORY_LIST: "/inventory/secondary",
    SECONDARY_INVENTORY_VIEW: "/inventory/secondary/:id",
    SECONDARY_INVENTORY_UPDATE: "/inventory/secondary/:id/update",
    SECONDARY_INVENTORY_CREATE: "/inventory/secondary/add",
    SECONDARY_CATALOGUE_LIST: "/catalogue/secondary",
    SECONDARY_CATALOGUE_VIEW: "/catalogue/secondary/:id",
    SECONDARY_CATALOGUE_UPDATE: "/catalogue/secondary/:id/update",
    SECONDARY_CATALOGUE_CREATE: "/catalogue/secondary/add",
    LEAD_VIEW: "/lead",
    QUOTATION: "/lead/quotation",
    LEAD_QUOTATION: "/quotation",
    QUOTATION_UPDATE: "/lead/quotation/:id/update",
    QUOTATION_CREATE: "/lead/:id/quotation/create",
    SECONDARY_QUOTATION_UPDATE: "/lead/quotation/:id/secondary-update",
    CATALOGUE: "/catalogue",
    SECONDARY_QUOTATION_CREATE: "/lead/:id/quotation/secondary-create",
    ORDER_LIST: "/order",
    STANDARD_LIST: "/standard",
    STANDARD_VIEW: "/standard/:id",
    STANDARD_UPDATE: "/standard/:id/update",
    STANDARD_CREATE: "/standard/add",
    BULK_UPLOAD: "/bulk-upload",
    CATEGORY: "/category",
    CATEGORY_UPDATE: (categoryId: number) => `/category/${categoryId}`,
    CATEGORY_CREATE: "/category/create",
    GRADE_CREATE: "/grade/add",
    WHATSAPP_TEMPLATE_LIST: "/whatsapp-template",
    WHATSAPP_TEMPLATE_CREATE: "/whatsapp-template/add",
    WHATSAPP_TEMPLATE_VIEW: "/whatsapp-template/:id",
    WHATSAPP_TEMPLATE_UPDATE: "/whatsapp-template/:id/update",
    MPC_LIST: "/mpc",
    CUSTOMER_LIST: "/customer-management",
    USER_PROFILE: "/user-profile",
    ATTRIBUTE_LIST: "/attribute",
    MTO_QUOTATION_CREATE: "/lead/:id/quotation/secondary-lot-create",
    MTO_QUOTATION_UPDATE: "/lead/quotation/:id/secondary-lot-update",
    UPC_LIST: "/upc",
    UPC_CREATE: "/upc/add",
    UPC_VIEW: "/upc/:id",
    UPC_UPDATE: "/upc/:id/update",
    IMAGE_MASTER_LIST: "/image-master",
    IMAGE_MASTER_ADD: "/image-master/add",
    IMAGE_MASTER_VIEW: "/image-master/:id",
    IMAGE_MASTER_UPDATE: "/image-master/:id/update",
    MPC_CREATE: "/mpc/add",
    MPC_UPDATE: "/mpc/:id/update",
    MPC_VIEW: "/mpc/:id",
    CUSTOMER_GROUP_MASTER_LIST : "/customer-group-master",
    CUSTOMER_GROUP_MASTER_CREATE : "/customer-group-master/add",
    CUSTOMER_GROUP_MASTER_UPDATE: "/customer-group-master/:id/update",
    UPC_LISTING: "/upc-listing-page",
    CUSTOMER_MANAGEMENT_VIEW: "/customer-management/customers/:id",
    CUSTOMER_MANAGEMENT_LIST: "/customer-management/customers",
    CUSTOMER_MANAGEMENT_CREATE: "/customer-management/customers/add",
    VENDOR_MANAGEMENT_LIST: "/vendors",
    VENDOR_MANAGEMENT_VIEW: "/vendors/:id",
    VENDOR_MANAGEMENT_CREATE: "/vendors/add",
    INSTANT_QUOTATION_LIST: "/instant-quotations",
    INSTANT_QUOTATION_CREATE: "/instant-quotations/add",
    INSTANT_QUOTATION_MODE: "/instant-quotations/:id/:mode",
    VAS_MASTER_CATEGORIES_LIST: "/vas-master-service",
    VAS_MASTER_CATEGORIES_CREATE: "/vas-master-service/add",
    VAS_MASTER_CATEGORIES_UPDATE: (serviceId: number) => `/vas-master-service/${serviceId}/update`,
    VAS_MASTER_CATEGORIES_VIEW: (serviceId: number) => `/vas-master-service/${serviceId}`,
    VAS_MASTER_USCS_LIST: "/vas-master-USCs",
    VAS_MASTER_USCS_CREATE: "/vas-master-USCs/add",
    VAS_MASTER_USCS_UPDATE: "/vas-master-USCs/:id/update",
    VAS_MASTER_USCS_VIEW: "/vas-master-USCs/:id",
    VAS_MASTER_MACHINES_LIST: "/vas-master-machines",
    VAS_MASTER_MACHINES_CREATE: "/vas-master-machines/add",
    VAS_MASTER_MACHINES_UPDATE: "/vas-master-machines/:id/update",
    VAS_MASTER_MACHINES_VIEW: "/vas-master-machines/:id",
}

export const CATEGORIES = {
    PRODUCT_CATEGORY: "productCategory",
}

export const MODE = {
    VIEW: "VIEW",
    ADD: "ADD",
    UPDATE: "UPDATE",
    EDIT: "EDIT",
    REVIEW: "REVIEW",
}

export const STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
}

export const initialPaginationValues: IPagination = {
    currentPage: 0,
    pageSize: 10,
    totalPages: 1,
    totalRecords: 0,
}

export const initialPaginationValuesV2: IPagination = {
  currentPage: 0,
  pageSize: 50,
  totalPages: 1,
  totalRecords: 0,
}

export const CUSTOMER_MANAGEMENT_TABS = {
  PROFILE: '1',
  BUSINESS_PROFILE: '2',
  BUSINESS_LOCATION: '3',
  KEY_PERSON_DETAIL: '4',
  MATERIALS: '5',
  STATUTORY_DOCUMENTS: '6',
  PREFERENCES: '7',
  CHANGE_PASSWORD: '8',
  CUSTOMER_MAPPING: '9'
}

export const sortOptions: option[] = [
  { value: "name,asc", label: "Name (Ascending)" },
  { value: "name,desc", label: "Name (Descending)" },
  { value: "createdAt,asc", label: "Created Date(Ascending)" },
  { value: "createdAt,desc", label: "Created Date(Descending)" },
];

export const CLASS_TYPES : option[] = [
  { value: "STANDARD", label: "Standard" },
  { value: "NON_STANDARD", label: "Non Standard" },
  { value: "SECONDARY", label: "Secondary" },
  { value: "SECONDARY_LOTS", label: "Secondary Lots" },
  { value: "MAKE_TO_ORDER", label: "Make To Order" },
];


export const secondaryInventorySortOptions: option[] = [
    { value: "createdAt,asc", label: "Created Date(Ascending)" },
    { value: "createdAt,desc", label: "Created Date(Descending)" },
];

export const secondaryCatalogueSortOptions: option[] = [
    { value: "catalogueName,asc", label: "Name (Ascending)" },
    { value: "catalogueName,desc", label: "Name (Descending)" },
    { value: "createdAt,asc", label: "Created Date(Ascending)" },
    { value: "createdAt,desc", label: "Created Date(Descending)" },
];

export const statusOptions: option[] = [
    { value: "ALL", label: "All" },
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
];

export const PACKAGING_TYPES: option[] = [
    { value: "WITHOUT_PACKAGING", label: "Without Packaging" },
    { value: "PLASTIC_PACKAGING", label: "Plastic Packaging" },
    { value: "METAL_PACKAGING", label: "Metal Packaging" },
    { value: "SEA_PACKAGING", label: "Sea Packaging" },
];

export const CLASS_TYPE = {
    STANDARD_NONSTANDARD: "STANDARD_NONSTANDARD",
    STANDARD: "standard",
    NONSTANDARD: "nonStandard",
    SECONDARY: "secondary"
}

export const PRODUCT_SECTION = {
  MASTER_UPC: "MASTER_UPC",
  BRAND_UPC: "BRAND_UPC",
  SECONDARY: "SECONDARY",
  INVENTORY: "INVENTORY"
}

export const LEAD_STATUS = {
    ALL: "ALL",
    ONGOING: "ONGOING",
    REJECTED: "REJECTED",
    ACCEPTED: "ACCEPTED",
    PUBLISHED: "PUBLISHED",
    NOTPUBLISHED: "NOTPUBLISHED"
}

export const RESOURCE_TYPE = {
  BRAND: "BRAND",
  CATALOGUE: "CATALOGUE",
  INVENTORY: "INVENTORY",
  MANUFACTURER: "MANUFACTURER",
  STANDARD_GRADE: "STANDARD_GRADE",
  PRODUCT_CATEGORY: "PRODUCT_CATEGORY",
  SECONDARY_INVENTORY:"SECONDARY_INVENTORY",
  SECONDARY_CATALOGUE: "SECONDARY_CATALOGUE",
  STANDARD_INVENTORY: "STANDARD_INVENTORY",
  STANDARD_CATALOGUES: "STANDARD_CATALOGUES",
  NONSTANDARD_CATALOGUES: "NONSTANDARD_CATALOGUES",
  PRODUCT_UPCS: "PRODUCT_UPCS",
  NON_STANDARD_INVENTORY: "NON_STANDARD_INVENTORY",
  BULK_UPLOAD: "BULK_UPLOAD",
  SECONDARY_LOT_CATALOGUES: "SECONDARY_LOT_CATALOGUES",
  IMAGE_MASTER: "IMAGE_MASTER",
  STEEL_BAZAAR: "STEEL_BAZAAR",
  VAS_MACHINES: "VAS_MACHINES"
}

export const CATALOGUE_TYPES = {
  CURRENT_INVENTORY: "currentInventory",
  MAKE_TO_ORDER: "makeToOrder",
  STANDARD_CURRENT_INVENTORY_CATALOGUES: "STANDARD_CURRENT_INVENTORY_CATALOGUES",
  STANDARD_MAKE_TO_ORDER_CATALOGUES: "STANDARD_MAKE_TO_ORDER_CATALOGUES",
}

export const RESOURCE_STATUS = {
  PUBLISHED: "Published",
  ACTIVE: "Active",
  COMPLETED: "Completed",
  PARTIALLY_COMPLETED: "Partially Completed",
  ACCEPTED: "Accepted",
  PENDING: "Pending",
  ONGOING: "Ongoing",
  INACTIVE: "Inactive",
  UNPUBLISHED: "Unpublished",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
  FAILED: "Failed",
  INVALID_SHEET: "Invalid Sheet",
  NOTPUBLISHED:  "Not Published",
  BLACK_LISTED: "Black Listed",
  DRAFT: 'Draft',
  IN_PROGRESS: "In Progress",
  REVISED: "Revised",
  CLOSED_WIN: "Closed Win",
  SENT: "Sent",
  CLOSED_LOST: "Closed Lost",
}

export interface IChargesProps {
    title: string;
    subTitle?: string | null;
    price: number;
    icon?: React.ReactNode;
    iconInfo?: string | null;
    showFullQuantity: boolean;
};

export const PRICE_DETAILS = (iconOverrides: Partial<IPriceDetails> = {}): IPriceDetails => {
    const defaultDetails: IPriceDetails = {
        subTotal: {
            title: "Sub Totals",
            subTitle: null,
            price: 0,
            icon: null,
            iconInfo: null,
            showFullQuantity: false,
        },
        warehouseCharges: {
            title: "Warehousing Charges",
            subTitle: null,
            price: 0,
            icon: null,
            iconInfo: null,
            showFullQuantity: true,
        },
        handlingCharges: {
            title: "Handling Charges",
            subTitle: null,
            price: 0,
            icon: null,
            iconInfo: null,
            showFullQuantity: true,
        },
        packagingCharges: {
            title: "Packaging Charges",
            subTitle: null,
            price: 0,
            icon: null,
            iconInfo: null,
            showFullQuantity: true,
        },
        otherCharges: {
            title: "Other Charges",
            subTitle: null,
            price: 0,
            icon: null,
            iconInfo: null,
            showFullQuantity: false,
        },
        GST: {
            title: "Add: GST",
            subTitle: null,
            price: 0,
            icon: null,
            iconInfo: null,
            showFullQuantity: false,
        },
        TCS: {
            title: "Less: TCS (if applicable)",
            subTitle: null,
            price: 0,
            icon: null,
            iconInfo: null,
            showFullQuantity: false,
        },
    };

    return {
        ...defaultDetails,
        ...iconOverrides,
    };
};

export const ORDER_STATUS = {
    ALL: "ALL",
    ONGOING: "ONGOING",
    CANCELLED: "CANCELLED",
    COMPLETED: "COMPLETED",
    PENDING: "PENDING",
}

export const RESOURCES: { 
    [key: string]: string 
} = {
    CATALOGUE: "Catalogue",
    DASHBOARD: "Dashboard",
    USERS_MANAGEMENT: "Users Management",
    VENDOR_MANAGEMENT: "Vendor Management",
    CUSTOMER_MANAGEMENT: "Customer Management",
    CUSTOMER_MANAGEMENT_V2: "Customer Management",

    USER_MANAGEMENT: "User Management",
    ROLES_PERMISSION: "Roles & Permission",
    PROCUREMENT: "Procurement",
    PURCHASE_DASHBOARD: "Purchase Dashboard",
    PURCHASE_REQUISITION: "Purchase Requisition",
    PURCHASE_INDENT: "Purchase Indent",
    REVERSE_AUCTION: "Reverse Auction",
    REVERSE_AUCTION_RFQ: "Reverse Auction RFQ",
    VENDOR_DISCOVERY: "Vendor Discovery",
    LIVE_AUCTION: "Live Auction",
    PURCHASE_ORDER: "Purchase Order",
    MATERIAL_INWARD: "Material Inward",
    GATE_ENTRY: "Gate Entry",
    GRN: "GRN",
    QUALITY_CHECK: "Quality Check",
    PUTAWAY: "Putway",
    VENDOR_PAYMENTS: "Vendor Payments",
    MISCELLANEOUS: "Miscellaneous",
    BULK_UPLOAD_TRACKING: "Bulk Upload Tracking",
    DOWNLOAD_FORMAT: "Download Format",
    BULK_UPLOAD: "Bulk Upload",
    SALES: "Sales",
    SALES_DASHBOARD: "Sales Dashboard",
    SALES_INDENT: "Sales Indent",
    FORWARD_AUCTION: "Forward Auction",
    SALES_RFQ: "Sales RFQ",
    CUSTOMER_DISCOVERY: "Customer Discovery",
    FORWARD_LIVE_AUCTION: "Forward Live Auction",
    SALES_LEAD: "Sales Lead",
    WHATSAPP_SALE: "Whatsapp Sale",
    SALES_ORDER: "Sales Order",
    MATERIAL_OUTWARD: "Material Outward",
    DELIVERY_ORDER: "Delivery Order",
    SALES_INVOICE: "Sales Invoice",
    GATE_OUT_ENTRY: "Gate Out Entry",
    CUSTOMER_PAYMENT: "Customer Payment",
    INVENTORY: "Inventory",
    STANDARD_PRIME: "Standard Prime",
    NON_STANDARD_PRIME: "Non-Standard Prime",
    SECONDARY: "Secondary",
    NON_STANDARD: "Non Standard",
    STANDARD: "Standard",
    SECONDARY_LOTS: "Secondary lots",
    STOCK_TRANSFER: "Stock Transfer",
    PROCESSING: "Processing",
    CURRENT_INVENTORY: "Current Inventory",
    MAKE_TO_ORDER: "Make To Order",
    OFFER_MANAGEMENT: "Offer Management",
    COMBO_OFFERS: "Combo Offers",
    PAYMENT_DISCOUNT: "Payment Discount",
    COUPON_MANAGEMENT: "Coupon Management",
    REPORT_ANALYTICS: "Report & Analytics",
    INVENTORY_AS_ON_DATE: "Inventory as on Date",
    INVENTORY_BIN_REPORT: "Inventory Bin Report",
    INVENTORY_AGING_REPORT: "Inventory Aging Report",
    ITEM_LEDGER_REPORT: "Item Ledger Report",
    PURCHASE: "Purchase",
    PURCHASE_CYCLE_REPORT: "Purchase Cycle Report",
    GRN_REPORT: "GRN Report",
    PO_REPORT: "PO Report",
    SALES_CYCLE_REPORT: "Sales Cycle Report",
    ORDER_DELIVERY_REPORT: "Order Delivery Report",
    AUCTION: "Auction",
    PURCHASE_AUCTION_REPORT: "Purchase Auction Report",
    SALES_AUCTION_REPORT: "Sales Auction Report",
    MASTERS: "Masters",
    COMPANY: "Company",
    PRODUCTS: "Products",
    STANDARD_GRADE: "Standard/Grade",
    ATTRIBUTE: "Attribute",
    CATEGORIES: "Categories",
    MANUFACTURER: "Manufacturer",
    BRAND: "Brand",
    UPC: "UPC",
    MPC: "MPC",
    WHATSAPP_TEMPLATE: "Whatsapp Templates",
    WAREHOUSE: "Warehouse",
    LOCATION: "Location",
    ZONE: "Zone",
    BIN: "Bin",
    WAREHOUSE_EMPLOYEE: "Warehouse Employee",
    TRANSPORT: "Transport",
    TRANSPORT_METHOD: "Transport Method",
    LOGISTIC_MANAGEMENT: "Logistic Management",
    QC: "QC",
    QC_MASTER: "QC Master",
    TAXES: "Taxes",
    GST: "GST",
    HSN: "HSN",
    TERMS_CONDITION: "Terms & Condition",
    FOR_CATALOG: "For Catalog",
    FOR_SALES: "For Sales",
    FOR_PROCUREMENT: "For Procurement",
    FOR_ITEM: "For Item",
    LEAD_MANAGEMENT: "Lead Management",
    MESSAGE_CENTER: "Message Center",
    LOG_OUT: "Log out",
    IMAGE_MASTER: "Image Master",
    CUSTOMER_GROUP_MASTER: "Customer Group Master",
    UPC_LISTING: "UPC Listing Page",
    MANAGE_QUOTATION: 'Instant Quotation',
    VAS_MASTER: "VAS Master",
    VAS_MASTER_CATEGORIES: "Categories",
    VAS_MASTER_USCs: "USCs",
    VAS_MASTER_MACHINES: "Machines",
    REPORTS_AND_ANALYTICS: "Reports & Analytics",
    VENDOR_COMPARISON: "Vendor Comparison"
}

export const STANDARD_SECTION_TYPE = {
  VIEW_STANDARD: "View Standard",
  EDIT_STANDARD: "Edit Standard",
  ADD_STANDARD: "Add New Standard",
}

export const BULK_UPLOAD_TEMPLATE_TYPE = {
  APPLICATION_OCTET_STREAM: 'application/octet-stream',
  APPLICATION_JSON: 'application/json',
}

export const BULK_UPLOAD_TEMPLATE_POPUP = {
  PLEASE_WAIT: "Please wait",
  UPLOAD_IN_PROGRESS: "Upload in progress",
  SUCCESS: "Success!",
  UPLOAD_PROCESS_SUCCESS: "Upload Process is completed successfully.",
  TRACK_PROGRESS_SUCCESS: "Please track the progress in the Bulk Upload Tracking screen",
  UPLOAD_FAILURE: "Upload Failure",
  FAILURE_ERROR: "There are some errors, For more detail please check the file.",
  DONE: "Done",
}
export const BULK_UPLOAD_FILE_TYPE = {
  EXCEL_XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
}

export const LANGUAGE_CODE: option[] =[
    {
      "label": "Afrikaans",
      "value": "af"
    },
    {
      "label": "Albanian",
      "value": "sq"
    },
    {
      "label": "Arabic",
      "value": "ar"
    },
    {
      "label": "Azerbaijani",
      "value": "az"
    },
    {
      "label": "Bengali",
      "value": "bn"
    },
    {
      "label": "Bulgarian",
      "value": "bg"
    },
    {
      "label": "Catalan",
      "value": "ca"
    },
    {
      "label": "Chinese (CHN)",
      "value": "zh_CN"
    },
    {
      "label": "Chinese (HKG)",
      "value": "zh_HK"
    },
    {
      "label": "Chinese (TAI)",
      "value": "zh_TW"
    },
    {
      "label": "Croatian",
      "value": "hr"
    },
    {
      "label": "Czech",
      "value": "cs"
    },
    {
      "label": "Danish",
      "value": "da"
    },
    {
      "label": "Dutch",
      "value": "nl"
    },
    {
      "label": "English",
      "value": "en"
    },
    {
      "label": "English (UK)",
      "value": "en_GB"
    },
    {
      "label": "English (US)",
      "value": "en_US"
    },
    {
      "label": "Estonian",
      "value": "et"
    },
    {
      "label": "Filipino",
      "value": "fil"
    },
    {
      "label": "Finnish",
      "value": "fi"
    },
    {
      "label": "French",
      "value": "fr"
    },
    {
      "label": "Georgian",
      "value": "ka"
    },
    {
      "label": "German",
      "value": "de"
    },
    {
      "label": "Greek",
      "value": "el"
    },
    {
      "label": "Gujarati",
      "value": "gu"
    },
    {
      "label": "Hausa",
      "value": "ha"
    },
    {
      "label": "Hebrew",
      "value": "he"
    },
    {
      "label": "Hindi",
      "value": "hi"
    },
    {
      "label": "Hungarian",
      "value": "hu"
    },
    {
      "label": "Indonesian",
      "value": "id"
    },
    {
      "label": "Irish",
      "value": "ga"
    },
    {
      "label": "Italian",
      "value": "it"
    },
    {
      "label": "Japanese",
      "value": "ja"
    },
    {
      "label": "Kannada",
      "value": "kn"
    },
    {
      "label": "Kazakh",
      "value": "kk"
    },
    {
      "label": "Kinyarwanda",
      "value": "rw_RW"
    },
    {
      "label": "Korean",
      "value": "ko"
    },
    {
      "label": "Kyrgyz (Kyrgyzstan)",
      "value": "ky_KG"
    },
    {
      "label": "Lao",
      "value": "lo"
    },
    {
      "label": "Latvian",
      "value": "lv"
    },
    {
      "label": "Lithuanian",
      "value": "lt"
    },
    {
      "label": "Macedonian",
      "value": "mk"
    },
    {
      "label": "Malay",
      "value": "ms"
    },
    {
      "label": "Malayalam",
      "value": "ml"
    },
    {
      "label": "Marathi",
      "value": "mr"
    },
    {
      "label": "Norwegian",
      "value": "nb"
    },
    {
      "label": "Persian",
      "value": "fa"
    },
    {
      "label": "Polish",
      "value": "pl"
    },
    {
      "label": "Portuguese (BR)",
      "value": "pt_BR"
    },
    {
      "label": "Portuguese (POR)",
      "value": "pt_PT"
    },
    {
      "label": "Punjabi",
      "value": "pa"
    },
    {
      "label": "Romanian",
      "value": "ro"
    },
    {
      "label": "Russian",
      "value": "ru"
    },
    {
      "label": "Serbian",
      "value": "sr"
    },
    {
      "label": "Slovak",
      "value": "sk"
    },
    {
      "label": "Slovenian",
      "value": "sl"
    },
    {
      "label": "Spanish",
      "value": "es"
    },
    {
      "label": "Spanish (ARG)",
      "value": "es_AR"
    },
    {
      "label": "Spanish (SPA)",
      "value": "es_ES"
    },
    {
      "label": "Spanish (MEX)",
      "value": "es_MX"
    },
    {
      "label": "Swahili",
      "value": "sw"
    },
    {
      "label": "Swedish",
      "value": "sv"
    },
    {
      "label": "Tamil",
      "value": "ta"
    },
    {
      "label": "Telugu",
      "value": "te"
    },
    {
      "label": "Thai",
      "value": "th"
    },
    {
      "label": "Turkish",
      "value": "tr"
    },
    {
      "label": "Ukrainian",
      "value": "uk"
    },
    {
      "label": "Urdu",
      "value": "ur"
    },
    {
      "label": "Uzbek",
      "value": "uz"
    },
    {
      "label": "Vietnamese",
      "value": "vi"
    },
    {
      "label": "Zulu",
      "value": "zu"
    }
  ]

  export const LEAD_CATALOGUE_TYPES = {
    ALL: "ALL",
    STANDARD: "STANDARD",
    SECONDARY: "SECONDARY",
    MAKE_TO_ORDER: "MAKE_TO_ORDER",
  }
  
export const DOCUMENT_TYPES = {
  IMAGE_JPEG: 'image/jpeg',
  IMAGE_PNG: 'image/png',
  IMAGE_WEBP: 'image/webp',
  IMAGE_SVG: 'image/svg'
}

export const RESOLUTIONS = {
  SECONDARY_INVENTORY: { width: 640, height: 680 , tolerance: 50},
  BRAND: {width: 3000, height: 3000, tolerance: 3000}
}

export const SHAPE_TYPES = [
  {
    label: "Single Length Coil",
    id: 'SINGLE_LENGTH_COIL'
  },
  {
    label: "Multi Welded Coil ",
    id: 'MULTI_WELDED_COIL'
  },
  {
    label: "Leader End Coil",
    id: 'LEADER_END_COIL'
  },
  {
    label: "Uniform Assorted Bundle Sheets",
    id: 'UNIFORM_ASSORTED_BUNDLE_SHEETS'
  },
  {
    label: "Mix Assorted Bundle Sheets",
    id: 'MIX_ASSORTED_BUNDLE_SHEETS'
  },
  {
    label: "Unassorted Bundle Sheets",
    id: 'UNASSORTED_BUNDLE_SHEETS'
  },
  {
    label: "Scroll",
    id: 'SCROLL'
  },
  {
    id: 'BAR',
    label: "Bar"
  },
  {
    id: 'PLATE',
    label: "Plate"
  }
]

export const ATTRIBUTES = {
  SPECIFICATION: "SPECIFICATION",
  GENERALIZATION: "GENERALIZATION",
  CLASSIFICATION: "CLASSIFICATION"
}

export const RANGE_ATTRIBUTES = ["length", "width", "thickness"]

export const EXCEPTION_CODE = {
  DUPLICATE_ENTRY : "DUPLICATE_ENTRY",
  NULL_POINTER : "NULL_POINTER",
  DATABASE_ERROR : "DATABASE_ERROR",
  MAPPING_ERROR : "MAPPING_ERROR",
  UNEXPECTED_ERROR : "UNEXPECTED_ERROR",
  INVALID_ARGUMENT : "INVALID_ARGUMENT",
  MAX_LIMIT_EXCEED : "MAX_LIMIT_EXCEED"
}

export const BRANDS = {
  SECONDARY_BRAND : "secondary brand",
}

export const TAB_MAPPING_BRAND_UPC = {
  UPC_OVERVIEW: '1',
  PRICE_MANAGEMENT: '2',
  CUSTOMER_WITH_UPC: '3',
  SALES_ORDER: '4',
  VENDOR_WITH_UPC: '5',
  PURCHASE_ORDER: '6',
  RELATED_UPC: '7',
  OTHER: '8',
  INVENTORY: '9'
}

export const TAB_MAPPING_MASTER_UPC = {
  UPC_OVERVIEW: '1',
  PRICE_MANAGEMENT: '2',
  CUSTOMER_WITH_UPC: '3',
  SALES_ORDER: '4',
  VENDOR_WITH_UPC: '5',
  PURCHASE_ORDER: '6',
  RELATED_UPC: '7',
  OTHER: '8',
  INVENTORY: '9'
}
export const COMMUNICATION_CHANNEL = [
  {
    label: "Email",
    value: "Email"
  },
  {
    label: "Phone",
    value: "Phone"
  },
  {
    label: "WhatsApp",
    value: "WhatsApp"
  }
];

export const CONTACT_PREFERENCE = [
  {
    label: "Email",
    value: "Email"
  },
  {
    label: "Phone",
    value: "Phone"
  },
  {
    label: "In person Meeting",
    value: "In person Meeting"
  }
];

export const LANGUAGE = [
  {
    label: "English",
    value: "English"
  },
  {
    label: "Hindi",
    value: "Hindi"
  }
];

export const CREDIT_PERIOD = [
  {
    label: "3 DAYS",
    value: "3 DAYS"
  },
  {
    label: "7 DAYS",
    value: "7 DAYS"
  },
  {
    label: "10 DAYS",
    value: "10 DAYS"
  },
  {
    label: "15 DAYS",
    value: "15 DAYS"
  }
];

export const PAYMENT_PREFERENCE = [
  {
    label: "Credit",
    value: "Credit"
  },
  {
    label: "Debit",
    value: "Debit"
  },
  {
    label: "Cash on Delivery",
    value: "Cash on Delivery"
  }
];

export const OTHER_PREFERENCE = [
  { id: 1, value: 'Receive updates via Whatsapp' },
  { id: 2, value: 'Would you like to join our Whatsapp community?' },
  { id: 3, value: 'Receive updates via email' },
  { id: 4, value: 'Grant permission for sharing documents for KYC and credit check' },
];
export const COUNTRY_CODES = [
  { name: "IND", code: "+91" }
];

export const HONORIFICS = [
  { value: "Mr.", label: "Mr." },
  { value: "Mrs.", label: "Mrs." }
]

export const SOCIAL_LINKS = [
  { label: 'Facebook', value: 'FACEBOOK' },
  { label: 'Twitter', value: 'TWITTER' },
  { label: 'Instagram', value: 'INSTAGRAM' },
  { label: 'LinkedIn', value: 'LINKEDIN' }
];

export const DOCUMENT_RESOURCE_TYPE = {
  BUSINESS_PROFILE_STATUTORY:"business_profile/statutory",
  BUSINESS_PROFILE_KEY_PERSON_DETAILS:"business_profile/key_person_details",
  BUSINESS_PROFILE_FINISHED_PRODUCT: (userId: string) => `business_profile/${userId}/finished_product`,
  BUSINESS_PROFILE_SCRAP: (userId: string) => `business_profile/${userId}/scrap`,
  VAS_MACHINE: "vas_machines"
};

export const certificateTypeOptions = [
  {
    label: "GSTIN",
    value: "GSTIN"
  },
  {
      label: "MSME",
      value: "MSME"
  },
  {
      label: "UDYAM",
      value: "UDYAM"
  }
];

export const ENTITY_TYPES = [
  { id: 'Large Corporate', name: 'Large Corporate' },
  { id: 'Sole Proprietorship', name: 'Sole Proprietorship' },
  { id: 'Medium Enterprise', name: 'Medium Enterprise' },
  { id: 'Small Enterprise', name: 'Small Enterprise' },
  { id: 'Micro Enterprise', name: 'Micro Enterprise' },
  { id: 'Mid Corporate', name: 'Mid Corporate' },
];

export const INDUSTRY_TYPES = [
  { label: 'Construction', value: 'CONSTRUCTION' },
  { label: 'Healthcare', value: 'HEALTHCARE' },
  { label: 'Insurance', value: 'INSURANCE' },
  { label: 'Manufacturing', value: 'MANUFACTURING' },
  { label: 'Mining', value: 'MINING' },
  { label: 'Retail', value: 'RETAIL' },
  { label: 'Services', value: 'SERVICES' },
  { label: 'Trade', value: 'TRADE' }
];

export const INDUSTRY_STATES =   {
  MANUFACTURING: 'Manufacturing',
  MINING: 'Mining',
  CONSTRUCTION: 'Construction',
  INSURANCE: 'Insurance',
  HEALTHCARE:'Healthcare',
  RETAIL: 'Retail',
  SERVICES: 'Services',
  TRADE: 'Trade'
};

export const BUSINESS_PROFILE_SECTIONS = {
  GST: "GST",
  UDHYAM: "UDHYAM",
  CIN: "CIN",
  TURN_OVERS: "TURN_OVERS",
  OTHER_INFORMATION: "OTHER_INFORMATION"
}

export const BUSINESS_CLASSIFICATION = [
  { id: 'SME', name: 'SME' },
  { id: 'MSME', name: 'MSME' },
];

export const TURNOVER_DROP_DOWN_OPTIONS = [
  { value: "Less than 40 Lakhs", label: "Less than 40 Lakhs" },
  { value: "40 L - 1 CR", label: "40 L - 1 CR" },
  { value: "1-5 CR", label: "1-5 CR" },
  { value: "5-10 CR", label: "5-10 CR" },
  { value: "10-20 CR", label: "10-20 CR" },
  { value: "20-50 CR", label: "20-50 CR" },
  { value: "50-100 CR", label: "50-100 CR" },
  { value: "100+ CR", label: "100+ CR" },
];

export const BUSINESS_TYPES = [
  { id: 'Distributor', name: 'Distributor' },
  { id: 'Partnership', name: 'Partnership' },
  { id: 'Limited Liability Company', name: 'Limited Liability Company' },
  { id: 'Sole proprietorship', name: 'Sole proprietorship' },
];
export const USER_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'BLACK_LISTED', label: 'Blacklisted' }
];

export const DEBOUNCE_TIME = {
  USER_STATUS_UPDATE: 2000,
  DEFAULT: 300
}
export const CLASSES = [
  {
    label: "Standard",
    id: 'STANDARD'
  },
  {
    label: "Secondary",
    id: 'SECONDARY'
  },
  // {
  //   label: "Non Standard",
  //   id: 'NONSTANDARD'
  // },
]

export const STATUS_OPTION = [
  {
    label: "Active",
    id: 'ACTIVE'
  },
  {
    label: "Inactive",
    id: 'INACTIVE'
  },
]

export const SORT_OPTION = [
  // {
  //   id: "name,asc",
  //   label: 'Name (Ascending)'
  // },
  // {
  //   id: "name,desc",
  //   label: 'Name (Descending)'
  // },
  {
    id: "createdAt,asc",
    label: 'Created Date(Ascending)'
  },
  {
    id: "createdAt,desc",
    label: 'Created Date(Descending)'
  },
]

export const cityOptions = [
  { id: "DELHI", label: "Delhi" },
  { id: "MUMBAI", label: "Mumbai" },
  { id: "NOIDA", label: "Noida" },
  { id: "BANGALORE", label: "Bangalore" },
  { id: "CHENNAI", label: "Chennai" },
  { id: "KOLKATA", label: "Kolkata" },
  { id: "HYDERABAD", label: "Hyderabad" },
  { id: "PUNE", label: "Pune" },
  { id: "AHMEDABAD", label: "Ahmedabad" },
  { id: "SURAT", label: "Surat" },
  { id: "LUCKNOW", label: "Lucknow" },
  { id: "JAIPUR", label: "Jaipur" },
  { id: "KANPUR", label: "Kanpur" },
  { id: "NAGPUR", label: "Nagpur" },
  { id: "BHOPAL", label: "Bhopal" },
  { id: "PATNA", label: "Patna" },
  { id: "LUDHIANA", label: "Ludhiana" },
  { id: "AGRA", label: "Agra" },
  { id: "NASHIK", label: "Nashik" },
  { id: "VADODARA", label: "Vadodara" },
  { id: "INDORE", label: "Indore" },
  { id: "COIMBATORE", label: "Coimbatore" },
  { id: "THANE", label: "Thane" },
  { id: "RANCHI", label: "Ranchi" },
  { id: "JABALPUR", label: "Jabalpur" },
  { id: "GHAZIABAD", label: "Ghaziabad" },
  { id: "VARANASI", label: "Varanasi" },
  { id: "MEERUT", label: "Meerut" },
  { id: "RAIPUR", label: "Raipur" },
  { id: "RAJKOT", label: "Rajkot" },
  { id: "JODHPUR", label: "Jodhpur" },
  { id: "KOCHI", label: "Kochi" },
  { id: "MYSORE", label: "Mysore" },
  { id: "TRIVANDRUM", label: "Trivandrum" },
  { id: "GURGAON", label: "Gurgaon" },
  { id: "FARIDABAD", label: "Faridabad" },
  { id: "ALLAHABAD", label: "Allahabad" },
  { id: "AMRITSAR", label: "Amritsar" },
  { id: "VIJAYAWADA", label: "Vijayawada" },
  { id: "AURANGABAD", label: "Aurangabad" },
  { id: "SOLAPUR", label: "Solapur" },
  { id: "GUWAHATI", label: "Guwahati" },
  { id: "TIRUCHIRAPPALLI", label: "Tiruchirappalli" },
  { id: "MADURAI", label: "Madurai" },
  { id: "SALEM", label: "Salem" },
  { id: "THIRUVANANTHAPURAM", label: "Thiruvananthapuram" },
  { id: "KOTA", label: "Kota" },
  { id: "KURUKSHETRA", label: "Kurukshetra" },
  { id: "AJMER", label: "Ajmer" },
  { id: "ALIGARH", label: "Aligarh" },
  { id: "AMBIKAPUR", label: "Ambikapur" },
  { id: "AMRAVATI", label: "Amravati" },
  { id: "ANAND", label: "Anand" },
  { id: "ANANTAPUR", label: "Anantapur" },
  { id: "ASANSOL", label: "Asansol" },
  { id: "AURANGABAD", label: "Aurangabad" },
  { id: "BILASPUR", label: "Bilaspur" },
  { id: "BOKARO", label: "Bokaro" },
  { id: "CALICUT", label: "Calicut" },
  { id: "CUDDALORE", label: "Cuddalore" },
  { id: "CUTTACK", label: "Cuttack" },
  { id: "DHANBAD", label: "Dhanbad" },
  { id: "DHARWAD", label: "Dharwad" },
  { id: "DIMAPUR", label: "Dimapur" },
  { id: "DURGAPUR", label: "Durgapur" },
  { id: "ELURU", label: "Eluru" },
  { id: "ETAWAH", label: "Etawah" },
  { id: "GANDHINAGAR", label: "Gandhinagar" },
  { id: "GAYA", label: "Gaya" },
  { id: "GORAKHPUR", label: "Gorakhpur" },
  { id: "GULBARGA", label: "Gulbarga" },
  { id: "GUNTUR", label: "Guntur" },
  { id: "GURDASPUR", label: "Gurdaspur" },
  { id: "HARIDWAR", label: "Haridwar" },
  { id: "HUBLI", label: "Hubli" },
  { id: "IMPHAL", label: "Imphal" },
  { id: "JALGAON", label: "Jalgaon" },
  { id: "JAMMU", label: "Jammu" },
  { id: "JAMSHEDPUR", label: "Jamshedpur" },
  { id: "JHANSI", label: "Jhansi" },
  { id: "JUNAGADH", label: "Junagadh" },
  { id: "KALYAN", label: "Kalyan" },
  { id: "KANCHIPURAM", label: "Kanchipuram" },
  { id: "KANNUR", label: "Kannur" },
  { id: "KARNAL", label: "Karnal" },
  { id: "KHARAGPUR", label: "Kharagpur" },
  { id: "KHARGHAR", label: "Kharghar" },
  { id: "KOLHAPUR", label: "Kolhapur" },
  { id: "KOLLAM", label: "Kollam" },
  { id: "KOTTAYAM", label: "Kottayam" },
  { id: "KURNOOL", label: "Kurnool" },
  { id: "LATUR", label: "Latur" },
  { id: "MANGALORE", label: "Mangalore" },
  { id: "MATHURA", label: "Mathura" },
  { id: "MOHALI", label: "Mohali" },
  { id: "NAGAPATTINAM", label: "Nagapattinam" },
  { id: "NANDED", label: "Nanded" },
  { id: "NELLORE", label: "Nellore" },
  { id: "PALAKKAD", label: "Palakkad" },
  { id: "PANIPAT", label: "Panipat" },
  { id: "PONDICHERRY", label: "Pondicherry" },
  { id: "ROHTAK", label: "Rohtak" },
  { id: "ROURKELA", label: "Rourkela" },
  { id: "SAHARANPUR", label: "Saharanpur" },
  { id: "SANGLI", label: "Sangli" },
  { id: "SILIGURI", label: "Siliguri" },
  { id: "SRINAGAR", label: "Srinagar" },
  { id: "THANJAVUR", label: "Thanjavur" },
  { id: "TIRUNELVELI", label: "Tirunelveli" },
  { id: "UDAIPUR", label: "Udaipur" },
  { id: "UDUPI", label: "Udupi" },
  { id: "ULHASNAGAR", label: "Ulhasnagar" },
  { id: "UTTARKASHI", label: "Uttarkashi" },
  { id: "WARANGAL", label: "Warangal" },
  { id: "YAMUNANAGAR", label: "Yamunanagar" },
  { id: "YAVATMAL", label: "Yavatmal" }
]

// export const businessClassificationOptions = [
//   { id: "LARGE_CORPORATE", label: "Large Corporate" },
//   { id: "MID_CORPORATE", label: "Mid Corporate" },
//   { id: "MEDIUM_ENTERPRISE", label: "Medium Enterprise" },
//   { id: "SMALL_ENTERPRISE", label: "Small Enterprise" },
//   { id: "MICRO_ENTERPRISE", label: "Micro Enterprise" },
//   { id: "SOLE_PROPRIETORSHIP", label: "Sole Proprietorship" },
// ]

export const businessClassificationOptions = [
  { id: "Large Corporate", label: "Large Corporate" },
  { id: "Mid Corporate", label: "Mid Corporate" },
  { id: "Medium Enterprise", label: "Medium Enterprise" },
  { id: "Small Enterprise", label: "Small Enterprise" },
  { id: "Micro Enterprise", label: "Micro Enterprise" },
  { id: "Sole Proprietorship", label: "Sole Proprietorship" },
]


export const turnOverOptions = [
  { id: "Less than 40 Lakhs", label: "Less than 40 Lakhs" },
  { id: "40 L - 1 CR", label: "40 L - 1 CR" },
  { id: "1-5 CR", label: "1-5 CR" },
  { id: "5-10 CR", label: "5-10 CR" },
  { id: "10-20 CR", label: "10-20 CR" },
  { id: "20-50 CR", label: "20-50 CR" },
  { id: "50-100 CR", label: "50-100 CR" },
  { id: "100+ CR", label: "100+ CR" },
]

export const industryOptions = [
  { value: "CONSTRUCTION", label: "Construction" },
  { value: "HEALTHCARE", label: "Healthcare" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "MANUFACTURING", label: "Manufacturing" },
  { value: "MINING", label: "Mining" },
  { value: "RETAIL", label: "Retail" },
  { value: "SERVICES", label: "Services" },
  { value: "TRADE", label: "Trade" },
]

export 	const groupTypeOptions = [
  { id: "VIP", label: "VIP" },
  { id: "STANDARD", label: "Standard" },
  { id: "PREMIUM", label: "Premium" },
]


export const importExportOptions = [
  { id: "IMPORT", label: "Import" },
  { id: "EXPORT", label: "Export" },
  { id: "BOTH", label: "Both" },
]


export const TRADE_TYPE = [
  { value: 'IMPORT', label: 'Import' },
  { value: 'EXPORT', label: 'Export' },
  { value: 'BOTH', label: 'Both' },
]

export const PREFERRED_DELIVERY_DATE = [
  { value: '1 Day', label: '1 Day' },
  { value: '3 Days', label: '3 Days' },
  { value: '5 Days', label: '5 Days' },
  { value: '7 Days', label: '7 Days' },
  { value: '9 Days', label: '9 Days' },
]

export const GENERIC_EXCEPTION_CODE = {
  DATA_NOT_FOUND: "DATA_NOT_FOUND",
  DUPLICATE_ENTRY: "DUPLICATE_ENTRY"
}

export const MATERIAL_REQUIREMENT_CONSTANT = {
  OTHER_PREFERENCE: "OTHER_PREFERENCE",
  BRAND_MANUFACTURER: "BRAND_MANUFACTURER",
  PRODUCT_CATEGORY: "PRODUCT_CATEGORY"
}

export const SCRAP_PRODUCTS = {
  MY_MATERIALS: "My Materials",
  SCRAP_PRODUCTS_LISTING: "Scrap Products Listing",
  CURRENT_SALES_MODE: "Current Sales Mode",
  ADD_NEW_SCRAP: "Add New Scrap",
  UPLOAD_IMAGE: "Upload Image",
  SCRAP_CATEGORY: "Scrap Category",
  TYPE_OF_SCRAP: "Type of Scrap",
  MONTHLY_GENERATED_QUANTITY: "Monthly generated quantity (MT)",
};

export const SCRAP_PRODUCTS_CATEGORY = [
  {
      value: "HMS",
      label: "Hms",
  },
  {
      value: "HOME_SCRAP",
      label: "Home Scrap",
  },
  {
      value: "INTERNAL_SCRAP",
      label: "Internal Scrap",
  },
  {
      value: "NEW_SCRAP",
      label: "New Scrap",
  },
  {
      value: "OBSOLETE_SCRAP",
      label: "Obsolete Scrap",
  },
  {
      value: "OLD_SCRAP",
      label: "Old Scrap",
  },
  {
      value: "POST_CONSUMER_SCRAP",
      label: "Post Consumer Scrap",
  },
  {
      value: "PRE_CONSUMER_SCRAP",
      label: "Pre Consumer Scrap",
  },
  {
      value: "PROMPT_SCRAP",
      label: "Prompt Scrap",
  },
  {
      value: "RECYCLING",
      label: "Recycling",
  },
  {
      value: "SCRAP_PROCESSING",
      label: "Scrap Processing",
  },
  {
      value: "STEEL_MAKING",
      label: "Steel Making",
  },
  {
      value: "STEEL_SCRAP",
      label: "Steel Scrap",
  },
]

export const SCRAP_PRODUCTS_TYPE = [
  {
      value: "ALUMINUM",
      label: "Aluminum",
  }, 
  {
      value: "STEEL",
      label: "Steel",
  }, 
  {
      value: "COPPER",
      label: "Copper",
  },
]

export const SCRAP_PRODUCTS_SALES = [
  {
      value: "ONLINE_SALES",
      label: "Online Sales",
  },
  {
      value: "ONLINE_MARKETPLACE",
      label: "Online Marketplace",
  },
  {
      value: "DIRECT_SALES",
      label: "Direct Sales",
  },
]

export const FINISHED_PRODUCTS = {
  MY_MATERIALS: "My Materials",
  FINISHED_PRODUCTS_LISTING: "Finished Products Listing",
  APPLICATION_TYPE: "Application Type",
  FINISHED_PRODUCT: "Finished Product",
  UPLOAD_IMAGE: "Upload Image",
  PRODUCT_NAME: "Product Name",
  PRODUCT_DESCRIPTION: "Product Description",
};

export const FINISHED_PRODUCTS_APPLICATION_TYPE = [
  {
      value: "FINISHED_PRODUCT",
      label: "Finished Product",
  },
  {
      value: "AUTOMOTIVE_PARTS",
      label: "Automotive Parts",
  },
  {
      value: "PACKAGING_MATERIAL",
      label: "Packaging Material",
  },
  {
      value: "CONSTRUCTION_MATERIAL",
      label: "Constructive Material",
  },
  {
      value: "CONSUMER_GOODS",
      label: "Consumer Goods",
  },
  {
      value: "ELECTRONIC_COMPONENTS",
      label: "Electronic Components",
  },
];


export const PASSWORD_CHECKLIST = {
  uppercase: "Includes a Uppercase Letter",
  minLength: "Minimum 8 Characters",
  lowercase: "Includes a Lowercase Letter",
  symbol: "Includes a Symbol",
  number: "Includes a Number"
}

export const MATERIAL_REQUIREMENT_APPLICATION_TYPE = [
  { id: "RAW_MATERIAL", name: "Raw Material" },
  { id: "RECYCLED_PRODUCT", name: "Recycled Product" },
  { id: "MANUFACTURING_COMPONENT", name: "Manufacturing Component" },
]

export const SOURCING_PURPOSE = [
  { id: "MANUFACTURING", name: "Manufacturing" },
  { id: "RESALE", name: "Resale" },
  { id: "EXPORT", name: "Export" },
]

export const FREQUENCY = [
  { id: "DAILY", name: "Daily" },
  { id: "WEEKLY", name: "Weekly" },
  { id: "MONTHLY", name: "Monthly" },
  { id: "QUARTERLY", name: "Quarterly" },
  { id: "ANNUALLY", name: "Annually" },
];

export const VALUE_ADDING_SERVICES = [
  { value: 'Shearing', label: 'SHEARING' },
  { value: 'Slitting', label: 'SLITTING' },
  { value: 'Blanking', label: 'BLANKING' },
  { value: 'Metal Printing', label: 'METAL_OFFSET_PRINTING' },
];

export const UPC_APPLICATIONS = [
  { label: "Aerospace", value: "AEROSPACE" },
  { label: "Appliances", value: "APPLIANCES" },
  { label: "Construction", value: "CONSTRUCTION" },
  { label: "Defense and Military", value: "DEFENSE_AND_MILITARY" },
  { label: "Automotive", value: "AUTOMOTIVE" },
  { label: "Pipelines", value: "PIPELINES" },
  { label: "Railways", value: "RAILWAYS" },
  { label: "Shipbuilding", value: "SHIPBUILDING" },
  { label: "Tinplate", value: "TINPLATE" },
  { label: "Tools and Machinery", value: "TOOLS_AND_MACHINERY" }
];

export const GENERIC_FILTER_SECTIONS = {
  UPC: "UPC",
  MATERIAL_FILTER: "MATERIAL_FILTER",
  OTHER: "OTHER",
  VENDOR_FILTER: "VENDOR_FILTER"
}

export const MY_MATERIAL_CUSTOMIZATION_ATTRIBUTE = ["THICKNESS", "WIDTH"]

export const VENDOR_TYPE = [
  {
    value: "PRIMARY_MANUFACTURER",
    label: "Primary Manufacturer",
  },
  {
    value: "SECONDARY_MANUFACTURER",
    label: "Secondary Manufacturer",
  },
  {
    value: "FINISHED_PRODUCT_MANUFACTURER",
    label: "Finished Product Manufacturer",
  },
  {
    value: "PROCESSOR",
    label: "Processor",
  },
  {
    value: "FABRICATORS",
    label: "Fabricators",
  },
  {
    value: "CHANNEL_PARTNER",
    label: "Channel Partner",
  },
  {
    value: "BRAND_DISTRIBUTOR_STOCKIST_IMPORTANT",
    label: "Brand Distributor/Stockist/Important"
  },
]

export const LEAD_SOURCE = [
  {
    value: "WHATSAPP",
    label: "WhatsApp",
  },
  {
    value: "FACE_TO_FACE_MEETINGS",
    label: "Face To Face Meetings",
  },
  {
    value: "COLD_OUTREACH",
    label: "Cold OutReach",
  },
  {
    value: "COLD_CALLING",
    label: "Cold Calling",
  },
  {
    value: "COLD_EMAILING",
    label: "Cold Emailing",
  },
  {
    value: "WEBSITE",
    label: "Website",
  },
  {
    value: "REFERRALS",
    label: "Referrals"
  },
  {
    value: "ORGANIC_SEARCH",
    label: "Organic Search"
  },{
    value: "B2B_MARKETPLACES",
    label: "B2b MarketPlaces"
  },{
    value: "DIRECT_MAIL_CAMPAIGNS",
    label: "Direct Mail Campaigns"
  },
]

export const LEAD_PRIORITY = [
  {
    value: "CRITICAL",
    label: "Critical",
  },
  {
    value: "HIGH",
    label: "High",
  },
  {
    value: "MEDIUM",
    label: "Medium",
  },
  {
    value: "LOW",
    label: "Low",
  },
]

export const QUOTATION_STATUS = [
  {
    value: "",
    label: "All",
  },
  {
    value: "DRAFT",
    label: "Draft",
  },
  {
    value: "SENT",
    label: "Sent",
  },
  {
    value: "IN_PROGRESS",
    label: "In Progress",
  },
  {
    value: "CLOSED_WIN",
    label: "Closed Win",
  },
  {
    value: "CLOSED_LOST",
    label: "Closed Lost",
  },
]

export const STATUS_CONST = {
  DRAFT : "DRAFT",
  SENT : "SENT",
  IN_PROGRESS : "IN_PROGRESS",
  CLOSED_WIN : "CLOSED_WIN",
  CLOSED_LOST : "CLOSED_LOST",
  REVISED : "REVISED",
}

export const SUCCESS_FAILURE_POPUP = {
  SUCCESS: "Success!",
  DELETE_PRODUCT: "Delete Product?",
  DELETE_SERVICE: "Delete Service?",
  QUOTATION_SENT: "Your quotation has been sent!",
  WANT_TO_DELETE: "Are you sure you want to delete this?",
  DOWNLOAD_PDF: "Download PDF",
  CONTINUE: "Continue",
  YES: "Yes",
  NO: "No",
}

export const TERMS_CONDITION_CONSTANT = `
1. A reference to Trader means Steelbazaar Pvt Ltd.
2. A reference to Buyers means the party who purchases the goods from the Trader.
3. A reference to Warehouse means the storage unit of the Trader.
4. The goods shall be as per the specifications of the Trader. All warranties or conditions, statutory or otherwise, as to quality or fitness for any particular purpose, whether known to the Trader or not, are excluded. The Buyers shall give the Trader written notice within seven days of receipt of goods, of any claim if goods are not of stated quality, to enable the Trader to investigate the complaint before the remainder of the consignment is used or returned to the Trader.
5. The Trader reserves the right to revise the price and its terms without notice or reason, even after acceptance of the Purchase order and/or payment. The price applicable shall be the price prevailing on the date and time of delivery.
6. Goods once sold shall not be taken back or exchanged by the Trader, except as stated in point 4 above.
7. Claims for shortages in the consignment must be settled directly with the carrier if arranged by the Buyer. The Trader will not be responsible for such claims once delivery is taken.
8. Any dispute arising from the contract shall be subject to the jurisdiction of courts of Delhi only.
9. All prices quoted are for delivery ex-warehouse/factory. The responsibility to arrange transport to collect the goods from the Trader's warehouse is per agreed sale terms. The Trader's responsibility ends once delivery is accepted by the Buyer. Transit Insurance and liability for transit losses are to the Buyer's account if the transport is arranged by the Buyer.
10. The Trader will make efforts to have goods ready at the warehouse per the D.O., based on best estimates, but shall not be liable for damages arising from delay in delivery. The Trader is not responsible for delays in dispatching goods.
11. Any taxes (including GST), cess, or duties levied on the sale, transportation, or delivery of goods shall be paid by the Buyer or reimbursed to the Trader if directly paid by the Trader.
12. All orders placed by the Buyer are subject to the Trader's acceptance, and the Trader may accept or refuse any order in full or part without assigning any reason.
13. The weights recorded in the Trader's dispatch certificate are final. Buyers may verify weights, but the Trader's recorded weights are conclusive.
14. The Trader shall not be liable for delays in dispatching goods due to causes beyond their control, such as Acts of God, war, strikes, Force Majeure, etc. In such cases, delivery may be suspended or canceled at the Trader's option without liability for damages.
15. If the Buyer fails to take delivery of goods when due, the Trader may cancel the deliveries in arrears or sell the remaining goods in the open market and claim any difference as well as damages.
16. If the Buyer fails to make payment when due, or breaches any terms, the Trader may cancel the contract or refuse further deliveries.
17. Cheque bouncing charges are Rs. 500 per instance.
18. A penalty of 30% p.a. would be charged if the payment is delayed beyond the committed date.`;

export const ADDRESS_TYPES = {
  BILLING: 'billing',
  SHIPPING: 'shipping',
}

export const LOCAL_PREVIOUS_URL_SECTIONS = {
  SECONDARY_INVENTORY_PREVIOUS_URL: "SecondaryInventoryLastVisitedUrl",
  NON_STANDARD_INVENTORY_PREVIOUS_URL: "NonStandardInventoryLastVisitedUrl",
  STANDARD_INVENTORY_PREVIOUS_URL: "StandardInventoryLastVisitedUrl",
}

export const SERVICE_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
];
export const SLITTING_HEADING = [
  "Sno.",
  "Width (MM)",
  "Weight of Coil (MT)",
  "CTW Charges/MT",
  "Total Charges",
  "Action"
]

export const SHEARING_HEADING = [
  "Sno.",
  "Length (MM)",
  "No. of Pieces",
  "Weight/Pc (MT)",
  "Weight (MT)",
  "CTL Charges/MT",
  "Total Charges",
  "Action"
]

export const CUSTOMIZTION_TYPE = {
  SLITTING: "SLITTING",
  SHEARING: "SHEARING",
  BLANKING: "BLANKING",
  METAL_OFFSET_PRINTING: "METAL_OFFSET_PRINTING"
}

export const SELECT_VAS_CUSTOMIZATION = {
  SELECT_CUSTOMIZATION: "Select Customization",
  SELECT_THE_VALUE: "Please select the value adding services you want",
  SELECTED_SERVICES: "You've selected following services:",
}

export const VENDOR_TYPES = [
  { value: 'PRIMARY_MANUFACTURER', label: 'Primary Manufacturer' },
  { value: 'SECONDARY_MANUFACTURER', label: 'Secondary Manufacturer' },
  { value: 'FINISHED_PRODUCT_MANUFACTURER', label: 'Finished Product Manufacturer' },
  { value: 'PROCESSOR', label: 'Processor' },
  { value: 'FABRICATORS', label: 'Fabricators' },
  { value: 'CHANNEL_PARTNER', label: 'Channel Partner' },
  { value: 'BRAND_DISTRIBUTOR_STOCKIST_IMPORTANT', label: 'Brand Distributor Stockist Important' }
]
